import { LinearProgress } from '@material-ui/core';
import styled from 'styled-components';

export const CustomLinearProgress = styled(LinearProgress)`
  transform: rotate(90deg);
  min-width: 40px;
  margin: 8px 0px;

  .MuiLinearProgress-barColorPrimary {
    background-color: #35ba83;
  }

  @media (min-width: 1320px) {
    transform: initial;
    min-width: 24px;
    margin: 0px;
    width: 100%;
  }
`;
